import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "items-count"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_DotNotification = _resolveComponent("DotNotification")!

  return (_ctx.isCountExist)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_BaseSubHeading, {
          size: "small",
          weight: "600",
          color: "monochrome-05",
          darkColor: "monochrome-04",
          className: "items-count__label"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.modifierCount), 1)
          ]),
          _: 1
        }),
        (_ctx.notify)
          ? (_openBlock(), _createBlock(_component_DotNotification, {
              key: 0,
              class: "items-count__indicator"
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}